import React from 'react'
import Styles from './SwitchStyles.module.css';
import { Switch } from 'antd';

export default function SwitchComp({val, onChangeFunc}) {
  return (
   <>
   <Switch checked={val} onChange={onChangeFunc} />
   </>
  )
}
